import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';

import * as rawJSONSchemaModuleGynaecology from '../../schemas/module-gynaecology.json';

class ModuleValueGynaecology extends ModuleValueGeneral {
  date_of_diagnosis?: string;
  date_of_birth?: string;
  date_of_surgery?: string;
  pre_existing_comorbidities?: string[];
  asa?: string;
  main_procedure?: string;
  primary_surgical_approach_hysterectomy?: string;
  discharge_date_hysterectomy?: string;
  length_of_stay_hysterectomy?: string;
  discharge_date_pelvic?: string;
  length_of_stay_pelvic?: string;
  discharge_date_resection?: string;
  length_of_stay_resection?: string;
  discharge_date_minor?: string;
  length_of_stay_minor?: string;
  discharge_date_salpingo?: string;
  length_of_stay_salpingo?: string;
  risk_indicator_hysterectomy?: string;
  discharge_date_myomectomy?: string;
  length_of_stay_myomectomy?: string;
  discharge_date_vulval?: string;
  length_of_stay_vulval?: string;
  // ICS-IUGA fields
  ics_enabled?: boolean;
  ics_code?: string;
  ics_category__mesh_removal?: string;
  ics_division_cat1__mesh_removal?: string;
  ics_division_cat2__mesh_removal?: string;
  ics_division_cat4__mesh_removal?: string;
  ics_division_cat5__mesh_removal?: string;
  ics_division_cat6__mesh_removal?: string;
  ics_division_cat7__mesh_removal?: string;
  ics_pain_cat1__mesh_removal?: string;
  ics_pain_cat1_readonly__mesh_removal?: string;
  ics_pain_cat2__mesh_removal?: string;
  ics_pain_cat2_readonly__mesh_removal?: string;
  ics_pain_cat4__mesh_removal?: string;
  ics_pain_cat5__mesh_removal?: string;
  ics_pain_cat6__mesh_removal?: string;
  ics_pain_cat7__mesh_removal?: string;
  ics_time__mesh_removal?: string;
  ics_site__mesh_removal?: string;
  ics_site_cat7__mesh_removal?: string;
}

export class SchemaModuleGynaecology extends SchemaModuleGeneral<ModuleValueGynaecology> {
  schema: JSONSchema<ModuleValueGynaecology>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleGynaecology );
  }

  hook( form: FormComponent ) {
    super.hook( form );

    this.listenValue( [ 'discharge_date_hysterectomy', 'date_of_surgery' ], this.fieldHandlerDischargeDate( 'length_of_stay_hysterectomy' ).bind( this ) );
    this.listenValue( [ 'discharge_date_pelvic', 'date_of_surgery' ], this.fieldHandlerDischargeDate( 'length_of_stay_pelvic' ).bind( this ) );
    this.listenValue( [ 'discharge_date_resection', 'date_of_surgery' ], this.fieldHandlerDischargeDate( 'length_of_stay_resection' ).bind( this ) );
    this.listenValue( [ 'discharge_date_minor', 'date_of_surgery' ], this.fieldHandlerDischargeDate( 'length_of_stay_minor' ).bind( this ) );
    this.listenValue( [ 'discharge_date_salpingo', 'date_of_surgery' ], this.fieldHandlerDischargeDate( 'length_of_stay_salpingo' ).bind( this ) );
    this.listenValue( [ 'discharge_date_myomectomy', 'date_of_surgery' ], this.fieldHandlerDischargeDate( 'length_of_stay_myomectomy' ).bind( this ) );
    this.listenValue( [ 'discharge_date_vulval', 'date_of_surgery' ], this.fieldHandlerDischargeDate( 'length_of_stay_vulval' ).bind( this ) );

    this.listenValue( [
      'main_procedure',
      'primary_surgical_approach_hysterectomy',
      'pre_existing_comorbidities',
      'date_of_surgery',
      'date_of_birth',
      'asa',
    ], this.fieldHandlerCalculateHysterectomyRiskIndicator.bind( this ) );

    this.listenValue( [
      'ics_enabled',
      'ics_category__mesh_removal',
      'ics_division_cat1__mesh_removal',
      'ics_division_cat2__mesh_removal',
      'ics_division_cat4__mesh_removal',
      'ics_division_cat5__mesh_removal',
      'ics_division_cat6__mesh_removal',
      'ics_division_cat7__mesh_removal',
      'ics_pain_cat1__mesh_removal',
      'ics_pain_cat1_readonly__mesh_removal',
      'ics_pain_cat2__mesh_removal',
      'ics_pain_cat2_readonly__mesh_removal',
      'ics_pain_cat4__mesh_removal',
      'ics_pain_cat5__mesh_removal',
      'ics_pain_cat6__mesh_removal',
      'ics_pain_cat7__mesh_removal',
      'ics_time__mesh_removal',
      'ics_site__mesh_removal',
      'ics_site_cat7__mesh_removal',
    ], this.fieldHandlerCalculateICSCode.bind( this ) );
  }

  setupValidators() {
    super.setupValidators();

    this.validatorDateComparison( 'date_of_diagnosis', 'date_of_birth', '>' );
    this.validatorDateComparison( 'date_of_surgery', 'date_of_birth', '>' );
    this.validatorDateComparison( 'date_of_surgery', 'date_of_diagnosis', '>=' );
    this.validatorDateComparison( 'discharge_date_hysterectomy', 'date_of_birth', '>' );
    this.validatorDateComparison( 'discharge_date_hysterectomy', 'date_of_surgery', '>=' );
    this.validatorDateComparison( 'discharge_date_pelvic', 'date_of_birth', '>' );
    this.validatorDateComparison( 'discharge_date_pelvic', 'date_of_surgery', '>=' );
    this.validatorDateComparison( 'discharge_date_resection', 'date_of_birth', '>' );
    this.validatorDateComparison( 'discharge_date_resection', 'date_of_surgery', '>=' );
    this.validatorDateComparison( 'discharge_date_minor', 'date_of_birth', '>' );
    this.validatorDateComparison( 'discharge_date_minor', 'date_of_surgery', '>=' );

    this.validatorDate( 'date_of_birth', ( new Date() ), '<=' , v => new Date( v as any ));
    this.validatorDate( 'date_of_diagnosis', ( new Date() ), '<=' , v => new Date( v as any ));
  }

  fieldHandlerCalculateHysterectomyRiskIndicator( main_procedure: string, approach: string, comorbs: string[], dateOfSurgery: string, dateOfBirth: string, asa: string ) {

    if ( !main_procedure || !approach || !comorbs || !dateOfSurgery || !dateOfBirth || !asa || main_procedure !== 'hysterectomy' ) {
      this.updateValue( 'risk_indicator_hysterectomy', '' );
      return;
    }

    const abdominal = [ 'abdominal', 'conversion_to_laparotomy' ].indexOf( approach ) != -1;

    const charlsonWeights = {
      // Weight 1
      myocardial: 1,
      congestive_heart_failure: 1,
      peripheral_vascular_disease: 1,
      dementia: 1,
      cerebrovascular_disease: 1,
      chronic_pulmonary_disease: 1,
      connective_tissue_disease: 1,
      // ulcer
      mild_liver_disease: 1,
      diabetes_mellitus: 1,

      // Weight 2
      hemiplegia: 2,
      moderate_or_severe_renal_disease: 2,
      diabetes_mellitus_with_end_organ_damage: 2,
      any_tumour: 2,
      leukaemia: 2,
      lymphoma: 2,

      // Weight 3
      moderate_or_severe_liver_disease: 3,

      // Weight 6
      // malignant tumor
      metastic_cancer: 6,
      aids: 6,

      // Other
      gord: 0,
      incomplete: 0,
      none: 0,
    };
    const charlson = ( comorbs ).reduce(( total, comorb ) => {
      const weight = charlsonWeights[ comorb ];
      if ( !isNaN( weight ) ) {
        total += weight;
      }
      return total;
    }, 0 );

    const dob = new Date( dateOfBirth );
    const dos = new Date( dateOfSurgery );
    const age = Math.floor( ( dos.valueOf() - dob.valueOf() ) / 1000 / 60 / 60 / 24 / 365.25 );

    const asa2 = [
      '2_mild_systemic_disease',
      '3_severe_systemic_disease',
      '4_life_threatening',
      '5_moribund',
      '6_brain_dead',
    ].indexOf( asa ) != -1;

    let score = -3.209;
    score += abdominal ? 0.723 : 0;
    score += charlson >= 2 ? 0.820 : 0;
    score += !isNaN( age ) && age > 0 && age < 50 ? 0.314 : 0;
    score += !isNaN( age ) && age >= 60 ? -0.454 : 0;
    score += asa2 ? 0.277 : 0;

    const outcomeProb = ( Math.E ** score ) * 100;

    this.updateValue( 'risk_indicator_hysterectomy', outcomeProb.toFixed( 2 ) );
  }

  fieldHandlerCalculateICSCode(
    ics_enabled: boolean,
    category: string,
    division_cat1: string, division_cat2: string, division_cat4: string, division_cat5: string, division_cat6: string, division_cat7: string,
    pain_cat1: string, pain_cat1_readonly: string, pain_cat2: string, pain_cat2_readonly: string, pain_cat4: string, pain_cat5: string, pain_cat6: string, pain_cat7: string,
    time: string,
    site: string,
    site_cat7: string
  ) {
    // If ICS is not enabled, clear the code
    if ( !ics_enabled || !category ) {
      this.updateValue( 'ics_code', '' );
      return;
    }

    // Get the appropriate division and pain based on category
    let division = '';
    let pain = '';

    switch ( category ) {
      case '1':
        division = division_cat1 || '';
        pain = ( division === 'A' ? 'a' : pain_cat1 ) || '';
        break;
      case '2':
      case '3':
        division = division_cat2 || '';
        pain = ( division === 'A' ? 'a' : pain_cat2 ) || '';
        break;
      case '4':
        division = division_cat4 || '';
        pain = pain_cat4 || '';
        break;
      case '5':
        division = division_cat5 || '';
        pain = pain_cat5 || '';
        break;
      case '6':
        division = division_cat6 || '';
        pain = pain_cat6 || '';
        break;
      case '7':
        division = division_cat7 || '';
        pain = pain_cat7 || '';
        break;
    }

    // Build the ICS code: CategoryDivisionpainTimeSite (no dashes)
    // If any field is not selected or "unspecified", use a space " " instead
    let code = '';

    // Category is always added if present
    if ( category ) {
      code += category;
    }

    // Division: space if empty or unspecified
    if ( !division || division === 'unspecified' ) {
      code += ' ';
    } else {
      code += division;
    }

    // Pain: space if empty or unspecified
    if ( !pain || pain === 'unspecified' ) {
      code += ' ';
    } else {
      code += pain;
    }

    // Time: space if empty or unspecified
    if ( !time || time === 'unspecified' ) {
      code += ' ';
    } else {
      code += time;
    }

    // Site: Use site_cat7 when category is 7 and division is B or C, otherwise use site
    let siteValue = site;
    if ( category === '7' && division && ['B', 'C'].indexOf(division) !== -1 ) {
      // For category 7 with division B or C, use site_cat7
      // Extract just the site code (e.g., "S0" from "S0 - No site applicable")
      if ( site_cat7 ) {
        siteValue = site_cat7.split(' ')[0]; // Extract "S0" from "S0 - No site applicable"
      } else {
        siteValue = '';
      }
    }

    // Site: space if empty or unspecified
    if ( !siteValue || siteValue === 'unspecified' ) {
      code += ' ';
    } else {
      code += siteValue;
    }

    // Format: CategoryDivisionpainTimeSite (e.g., 2BcT2S2 or 2B   S2 if some fields not selected)
    this.updateValue( 'ics_code', code );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-gynaecology.ts